// extracted by mini-css-extract-plugin
module.exports = {"widget":"Item_widget__25I9m","label":"Item_label__34MBP"};